import React from 'react';
import '../styles/policy.css'; // Το CSS αρχείο για styling

const CookiesPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Πολιτική Cookies</h1>

      <h2>Τι είναι τα cookies;</h2>
      <p>
        Τα cookies είναι μικρά αρχεία κειμένου που αποθηκεύονται στη συσκευή σας όταν επισκέπτεστε μια ιστοσελίδα. 
        Χρησιμοποιούνται για να βελτιώσουν την εμπειρία σας, αποθηκεύοντας τις προτιμήσεις σας και άλλες πληροφορίες.
      </p>

      <h2>Τι είδη cookies χρησιμοποιούμε;</h2>
      <p>Στο site μας χρησιμοποιούμε τους παρακάτω τύπους cookies:</p>
      <ul>
        <li><strong>Απαραίτητα cookies:</strong>  Είναι απαραίτητα για τη λειτουργία του ιστότοπου και δεν μπορούν να απενεργοποιηθούν. Χρησιμοποιούνται για να διευκολύνουν βασικές λειτουργίες, όπως η φόρμα επικοινωνίας και η χρήση του Calendly για τον προγραμματισμό ραντεβού.</li>
        <li><strong>Cookies επιδόσεων:</strong> Μας βοηθούν να κατανοήσουμε τον τρόπο που οι επισκέπτες χρησιμοποιούν τον ιστότοπό μας, ώστε να βελτιώσουμε την εμπειρία πλοήγησης. Αυτά τα cookies συλλέγουν ανώνυμες πληροφορίες σχετικά με τη χρήση του ιστότοπου. (π.χ., Google Analytics).</li>
        <li><strong>Cookies διαφήμισης:</strong> Δεν χρησιμοποιούμε cookies για προωθητικούς σκοπούς. Ο ιστότοπός μας επικεντρώνεται αποκλειστικά στην παροχή υπηρεσιών ψυχολογικής υποστήριξης.</li>
      </ul>

      <h2>Πώς χρησιμοποιούμε τα cookies;</h2>
      <p>Χρησιμοποιούμε τα cookies για να:</p>
      <ul>
        <li>Κατανοήσουμε τη συμπεριφορά των επισκεπτών και να βελτιώσουμε το site μας.</li>
        <li>Αποθηκεύσουμε τις προτιμήσεις σας (όπως γλώσσα και θέμα).</li>
      </ul>

      <h2>Πώς να διαχειριστείτε τα cookies;</h2>
      <p>
      Μπορείτε να επιλέξετε να διαχειριστείτε τις ρυθμίσεις των cookies μέσω του προγράμματος περιήγησής σας. Παρακαλώ σημειώστε ότι η απενεργοποίηση ορισμένων cookies μπορεί να επηρεάσει τη λειτουργικότητα του ιστότοπου.
      </p>

      <p>
        Για περισσότερες πληροφορίες, επισκεφθείτε την <a href="/privacy-policy">Πολιτική Απορρήτου</a> μας.
      </p>
    </div>
  );
};

export default CookiesPolicy;
